// extracted by mini-css-extract-plugin
export default {"form-get-email":"ForgotPassword_form-get-email__2zBYI","button-submit":"ForgotPassword_button-submit__6XICH","loading":"ForgotPassword_loading__sC4c6"};